import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";
import { Container } from "./ui-kit";

const KEY = "ksn_cookie_consent";

const applyAnalytics = (accepted) => {
  try {
    if (window.posthog) {
      if (accepted) window.posthog.opt_in_capturing();
      else window.posthog.opt_out_capturing();
    }
  } catch (e) {
    /* noop */
  }
};

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) {
      applyAnalytics(false); // opt-in: analytics off until consent
      setShow(true);
    } else {
      applyAnalytics(v === "accepted");
    }
  }, []);

  const decide = (accepted) => {
    localStorage.setItem(KEY, accepted ? "accepted" : "rejected");
    applyAnalytics(accepted);
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-[60] bg-ink text-white shadow-[0_-10px_40px_rgba(0,0,0,0.25)]" data-testid="cookie-consent">
      <Container className="py-5 flex flex-col lg:flex-row lg:items-center gap-5">
        <div className="flex items-start gap-3 flex-1">
          <Cookie size={22} strokeWidth={1.6} className="text-brand shrink-0 mt-0.5" />
          <p className="text-[13px] leading-relaxed text-white/85">
            Deneyiminizi iyileştirmek için zorunlu çerezleri kullanıyoruz. Ziyaret istatistiklerini ölçen analitik
            çerezler yalnızca onayınızla çalışır. Ayrıntılar için{" "}
            <Link to="/cerez-politikasi" className="underline text-white hover:text-brand transition-colors" data-testid="cookie-policy-link">
              Çerez Politikası
            </Link>
            .
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={() => decide(false)}
            data-testid="cookie-reject"
            className="h-11 px-6 rounded-full border border-white/30 text-[13px] font-semibold hover:border-white transition-colors"
          >
            Reddet
          </button>
          <button
            onClick={() => decide(true)}
            data-testid="cookie-accept"
            className="h-11 px-6 rounded-full bg-brand hover:bg-brandDark text-[13px] font-semibold transition-colors"
          >
            Kabul Et
          </button>
        </div>
      </Container>
    </div>
  );
};

export default CookieConsent;
